import React, { useState } from "react";
import styles from "./Login.module.scss";
import EyeIcon from "../../../assets/icons/EyeIcon";
import { useForm } from "react-hook-form";
import { login } from "../../../api/authApi";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useNotification } from "../../../contexts/NotificationToast";
import { useTheme } from "../../../contexts/ThemeContext";

const Login = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const { lightTheme } = useTheme();
  const [error, setError] = useState(null);
  lightTheme();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      const response = await login(data);

      const { access_token, refresh_token } = response.data;
      localStorage.setItem("access_token", access_token);
      localStorage.setItem("refresh_token", refresh_token);
      console.log("DATADATADATA", response?.data);
      showNotification(response.data.message, response.status);
      if (response?.status === 200) {
        navigate("/main");
      } else {
        console.log("Деталі помилки:", response?.data);
      }
    } catch (error) {
      console.log("Деталі помилки:", error);
      showNotification(error?.response?.data?.detail, error?.response?.status);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className={styles.loginPage}>
      <h1>Welcome!</h1>
      <p className={styles.loginText}>Log in to enter your account</p>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.loginInputContainer}>
          <label>Email</label>
          <input
            className={styles.loginInput}
            {...register("email", {
              required: "Login or email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Invalid email format",
              },
            })}
          />
          {errors.email && (
            <p className={styles.error}>{errors.email.message}</p>
          )}
        </div>
        <div className={styles.loginInputContainer}>
          <label>Password</label>

          <input
            type={showPassword ? "text" : "password"}
            className={styles.loginInput}
            {...register("password", {
              required: "Password is required",
              minLength: {
                value: 6,
                message: "Password must be at least 6 characters long",
              },
            })}
          />
          <EyeIcon
            className={styles.inputEye}
            onClick={() => setShowPassword(!showPassword)}
          />

          {errors.password && (
            <p className={styles.error}>{errors.password.message}</p>
          )}
        </div>
        {error}
        <p className={styles.loginText}>Forgot your password?</p>
        <CustomButton blue isLoading={isLoading} type="submit">
          Login
        </CustomButton>
        <p className={styles.loginText}>
          You do not have an account?{" "}
          <Link className={styles.link} to="/auth/register">
            Register
          </Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
